import $http from '../helpers/Axios';
import getBetType from '../helpers/getBetType';

export default {
  async systemInfo({ state, commit }, payload) {
    let res = await $http.post('/querySystemInfo.do');
    state.systemInfo = Object.assign({}, res.data.returnMap);
    state.qiniuUrl = res.data.returnMap.qnyAddress || '';
    state.linkUrl = res.data.returnMap.officialWebsite;
    return res;
  },
  async indexPageInfo({ state }, payload) {
    // let res = await $http.post('/indexPage.do');
    let res = await $http.post('/indexPageForNewKCW.do');
    // 0,时时彩;1 PK10,2 11选5,3 幸运28,4 快3, 5 六合彩,6 牛牛,7低频彩,8快乐10分
    if (res.data.returnCode == '0000') {
      res.data.returnMap.hotGame.forEach(x => {
        x.type = getBetType(x.parentType);
      });
      //头部跑马灯文字内容
      state.bulletinContent = res.data.returnMap.bulletinContent;
      state.hotGame = res.data.returnMap.hotGame;
      // console.log('jot', res.data.returnMap);
      // if (!res.data.returnMap.indexGame) {
      //   return
      // }
      // res.data.returnMap.indexGame.forEach(x => {
      //   x.type = getBetType(x.parentType);
      // });

      state.indexGame = res.data.returnMap.hotGame;
      let bannerList = {};
      res.data.returnMap.bannerList.forEach(x => {
        bannerList[x.bannerId] = x;
      });
      state.bannerList = Object.assign({}, bannerList);
      let allGame = res.data.returnMap.allGameTypeList.reduce((a, b) => {
        if (getBetType(b.parentType)) {
          b.type = getBetType(b.parentType);
          a[b.gameType] = b;
        } else {
          console.info('未定义betType:', b.gameType);
        }
        return a;
      }, {});
      // console.log(allGame);
      state.allGame = Object.assign({}, allGame);
    }

    return res;
  },
  async querySaleGameInfo({ state }, { gameType }) {
    let res = await $http.post('/querySaleGameInfo.do', {
      gameType
    });
    return res;
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js